/**
 * Populated "My story" for /demo/fertility/myjourney (Maya · cycle 2 · stim day 8).
 * Merges under any saved user timeline so edits persist.
 */
export const DEMO_FERTILITY_MY_STORY_TIMELINE = {
  ivf_protocol: {
    cycle_number: 2,
    cycle_day: 8,
    follicles: 12,
    eggs_retrieved: 0,
    fertilized: 0,
    embryos: 0,
    transfers: 0,
    protocol_type: 'Antagonist',
    clinic_name: 'Ohio Fertility Network',
    diagnosis: 'Unexplained',
    retrieval_date: '2026-04-12',
    transfer_date: '',
    partner_factor: 'No male factor identified',
    stim_meds: 'Gonal-F 225 IU, Menopur 75 IU, Cetrotide',
    amh: '2.1 ng/mL',
    prior_losses: '1 biochemical pregnancy (2024)',
  },
  cycle_data: {
    months_trying: 18,
    avg_cycle_length: 28,
    last_period_date: '2026-03-08',
    tracking_method: 'Clinic monitoring + app',
  },
  key_dates: {
    retrieval_date: '2026-04-12',
    transfer_date: '',
  },
};

export function mergeDemoFertilityMyStoryTimeline(base) {
  const d = DEMO_FERTILITY_MY_STORY_TIMELINE;
  const deep = {
    ivf_protocol: { ...d.ivf_protocol, ...(base?.ivf_protocol || {}) },
    cycle_data: { ...d.cycle_data, ...(base?.cycle_data || {}) },
    key_dates: { ...d.key_dates, ...(base?.key_dates || {}) },
  };
  return {
    ...d,
    ...(base || {}),
    ...deep,
  };
}
